import { Hint } from "@/components/portfolio/Hint";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/Tooltip";
import { useLanguage } from "@/context/LanguageContext";
import { RectangleGroupIcon } from "@heroicons/react/20/solid";
import { ChartNoAxesCombined } from "lucide-react";

interface GraphToggleProps {
  isGraphView: boolean;
  setIsGraphView: (val: boolean) => void;
  disabled?: boolean;
  showHint?: boolean;
}

export function GraphToggle({
  isGraphView,
  setIsGraphView,
  disabled,
  showHint = true,
}: GraphToggleProps) {
  const { language } = useLanguage();
  const copy = {
    cs: {
      disabled:
        "Analytický přehled je k dispozici pouze v členství Profesionál",
      hideAnalytics: "Schovat analytický přehled",
      showAnalytics: "Zobrazit analytický přehled",
      hint: "Podívejte se na vývoj cen",
    },
    en: {
      disabled: "Analytics view is available only with Professional membership",
      hideAnalytics: "Hide analytics view",
      showAnalytics: "Show analytics view",
      hint: "View price development",
    },
  }[language];
  return (
    <div className="w-fit flex ml-auto button_icons_container_slide">
      <div className="group">
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                className={`
              relative w-14 h-5 rounded-full shadow cursor-pointer 
              transition-colors duration-200
              ${disabled ? "opacity-50 cursor-not-allowed" : ""}
            `}
                onClick={() => !disabled && setIsGraphView(!isGraphView)}
              >
                {/* Sliding icon */}
                <div
                  className={`
                absolute -top-1.5 left-0.5 size-8 rounded-full flex items-center justify-center
                transform transition-transform duration-200 bg-background
                ${isGraphView ? "translate-x-0" : "translate-x-5"}
              `}
                >
                  {isGraphView ? (
                    <ChartNoAxesCombined className="size-5 text-foreground" />
                  ) : (
                    <RectangleGroupIcon className="size-5 text-foreground" />
                  )}
                </div>
              </div>
            </TooltipTrigger>

            <TooltipContent side="top" sideOffset={15}>
              {disabled
                ? copy.disabled
                : isGraphView
                  ? copy.hideAnalytics
                  : copy.showAnalytics}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      {showHint ? (
        <div className="absolute top-16 -right-2 z-20">
          <Hint preference="analyticsViewTip" text={copy.hint} showArrow={true} />
        </div>
      ) : null}
    </div>
  );
}
